export const config = {
    SOCKET_URL: "ws://localhost:8000/socket.io",
    PROD_SOCKET_URL: "ws://35.225.56.59:80/socket.io"
}